// extracted by css-extract-rspack-plugin
export default {"card":"card-shN3EI"};